import {InjectionToken} from '@angular/core';
import {IUiService} from './ui-service.interface';

export const UI_SERVICE = new InjectionToken<IUiService>('UI_SERVICE');
